export enum IEventType {
    SUCCESS = "1",
    ERROR = "2"
}
